module.exports = __webpack_public_path__ + "img/icon-bargainPrice.dd4388ec.png";